import { BaseURl } from "./BaseApiUrl";

//https://testcockpit.p2k.in/api/userdetails/userDailyCallingJourney/v1/?employeeUUID=bfa9b0ff-49be-11ef-bab4-22f17ecb52c5&journeyDate=01/02/2025&isPagination=1&pageNo=1&perPageRec=10
export const getUsersDailyCallingJourneyReportAPIURL = BaseURl + "userdetails/userDailyCallingJourney/v1/";